import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getBaseAssetTypes, saveBatchBaseAssetTypes } from '../../api/baseAssetTypes';
import type { BaseAssetType } from '../../types/BaseAssetType';
import { t } from '../../i18n/t';

const columnDefs: ColDef<BaseAssetType>[] = [
  {
    field: 'baseAssetTypeId',
    headerName: t('baseAssetTypes.columns.baseAssetTypeId'),
    width: 140,
    cellDataType: 'number',
    editable: (params: EditableCallbackParams<BaseAssetType>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    sort: 'asc',
  },
  { field: 'baseAssetTypeName', headerName: t('baseAssetTypes.columns.baseAssetTypeName'), flex: 1, editable: true },
];

const newRowDefaults = (): Partial<BaseAssetType> => ({ baseAssetTypeId: 0, baseAssetTypeName: '' });

export function BaseAssetTypesPage() {
  return (
    <LopCrudPage<BaseAssetType>
      resourceCode="baseAssetTypes"
      titleKey="baseAssetTypes.pageTitle"
      idField="baseAssetTypeId"
      getRows={getBaseAssetTypes}
      saveBatch={(added, modified, deletedIds) => saveBatchBaseAssetTypes(added, modified, deletedIds as number[])}
      columnDefs={columnDefs}
      newRowDefaults={newRowDefaults}
    />
  );
}
